<template>
	<div class="home">
		<div class="container container-price">
			<h1 class="title">{{ $t('feeSchedule') }}</h1>
			<table class="fee-table">
				<thead>
					<tr>
						<th class="table-header">{{ $t('memberLevel') }}</th>
						<th class="table-header">{{ $t('annualFee') }}</th>
						<th class="table-header">{{ $t('dailySearchUpload') }}</th>
						<th class="table-header">{{ $t('windowItems') }}</th>
						<th class="table-header">{{ $t('dailyWindowRefresh') }}</th>
						<th class="table-header">{{ $t('customerServiceHours') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(level, index) in memberLevels" :key="index" class="table-row">
						<td class="table-cell vip-level">{{ level.name }}</td>
						<td class="table-cell">{{ level.fee }}</td>
						<td class="table-cell">{{ level.searchUpload }}</td>
						<td class="table-cell">{{ level.windowItems }}</td>
						<td class="table-cell">{{ level.windowRefresh }}</td>
						<td class="table-cell">{{ level.customerService }}</td>
					</tr>
				</tbody>
			</table>
			<button class="contact-btn">{{ $t('contactServiceNow') }}</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'JoinUs',
		data() {
			return {
				memberLevels: [
					{
						name: 'VIP1',
						fee: '10000.00',
						searchUpload: '100',
						windowItems: '500',
						windowRefresh: '50',
						customerService: '12'
					},
					{
						name: 'VIP2',
						fee: '20000.00',
						searchUpload: '200',
						windowItems: '1000',
						windowRefresh: '100',
						customerService: '12'
					},
					{
						name: 'VIP3',
						fee: '30000.00',
						searchUpload: '300',
						windowItems: '1500',
						windowRefresh: '150',
						customerService: '24'
					},
					{
						name: 'VIP4',
						fee: '40000.00',
						searchUpload: '400',
						windowItems: '2000',
						windowRefresh: '200',
						customerService: '24'
					},
					{
						name: 'VIP5',
						fee: '50000.00',
						searchUpload: '500',
						windowItems: '2500',
						windowRefresh: '250',
						customerService: '24'
					}
				]
			}
		},
		methods: {
			contactService() {
				// 联系客服的处理逻辑
				console.log('联系客服');
			}
		}
	}
</script>

<style scoped>
	.home {
		width: 100%;
		background: #110616;
		min-height: 100vh;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		padding: 40px 0;
		box-sizing: border-box;
	}

	.container {
		width: 100%;
		max-width: 1200px;
	}
	
	.container-price{
		background: #00204C;
		padding: 40px;
		border-radius: 20px;
	}

	.title {
		text-align: center;
		color: #FFFFFF;
		font-size: 38px;
		font-weight: bold;
		margin-bottom: 10px;
		letter-spacing: 2px;
	}

	.fee-table {
		width: 100%;
		border-collapse: collapse;
	}

	.table-header {
		background: #016AF8;
		color: #FFFFFF;
		font-weight: bold;
		padding: 18px;
		text-align: center;
		font-size: 16px;
		border: 1px solid #797979;
	}

	.table-row {
		background: #0A1E40;
	}

	.table-row:nth-child(odd) {
		background: transparent;
	}

	.table-row:nth-child(even) {
		background: transparent;
	}

	.table-cell {
		color: #FFFFFF;
		padding: 20px 18px;
		text-align: center;
		font-size: 16px;
		border: 1px solid #797979;
	}

	.vip-level {
		font-weight: bold;
	}

	.contact-btn {
		display: block;
		width: 100%;
		max-width: 1200px;
		margin: 40px auto 0;
		padding: 18px;
		background: #F7931E;
		color: #FFFFFF;
		border: none;
		border-radius: 8px;
		font-size: 20px;
		font-weight: bold;
		cursor: pointer;
		transition: background-color 0.3s ease;
	}

	.contact-btn:hover {
		background: #E68419;
	}

	/* 响应式设计 */
	@media (max-width: 992px) {
		.title {
			font-size: 28px;
		}

		.table-header,
		.table-cell {
			padding: 12px 8px;
			font-size: 14px;
		}

		.contact-btn {
			font-size: 18px;
			padding: 16px;
		}
	}

	@media (max-width: 768px) {
		.home {
			padding: 20px 10px;
		}

		.title {
			font-size: 24px;
			margin-bottom: 20px;
		}

		.table-header,
		.table-cell {
			padding: 8px 4px;
			font-size: 12px;
		}

		.contact-btn {
			font-size: 16px;
			padding: 14px;
		}
	}
</style>